/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Example_ApiInputs */

const en_mk_team_example_api = /** @type {(inputs: Mk_Team_Example_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 2 · Data service`)
};

const id_mk_team_example_api = /** @type {(inputs: Mk_Team_Example_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 2 · Layanan data`)
};

/**
* | output |
* | --- |
* | "Agent 2 · Data service" |
*
* @param {Mk_Team_Example_ApiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_example_api = /** @type {((inputs?: Mk_Team_Example_ApiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Example_ApiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_example_api(inputs)
	return en_mk_team_example_api(inputs)
});